var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVigilance = function SvgVigilance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20 22.083a1.25 1.25 0 0 0 0 2.5h.017a1.25 1.25 0 0 0 0-2.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 15.417a7.917 7.917 0 1 0 0 15.833 7.917 7.917 0 0 0 0-15.833m-3.83 4.086a5.417 5.417 0 1 1 7.66 7.661 5.417 5.417 0 0 1-7.66-7.66",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.667 3.75A2.917 2.917 0 0 0 3.75 6.667V10a2.917 2.917 0 0 0 2.917 2.917h.416v10.417a12.917 12.917 0 1 0 25.834 0V12.917h.416A2.917 2.917 0 0 0 36.25 10V6.667a2.917 2.917 0 0 0-2.917-2.917zm-.295 2.622a.42.42 0 0 1 .295-.122h26.666a.417.417 0 0 1 .417.417V10a.417.417 0 0 1-.417.417H6.667A.416.416 0 0 1 6.25 10V6.667c0-.11.044-.217.122-.295m3.211 16.962V12.917h20.834v10.417a10.417 10.417 0 1 1-20.834 0",
    clipRule: "evenodd"
  })));
};
export default SvgVigilance;